<template lang="pug">
.seletor-filtro
  .chip.row.ac(v-if="value")
    b {{ value.id }}
    span {{ value.nome }}
    button.chip-x(type="button" @click="limpar" title="Trocar") ×
  template(v-else)
    input.input(:id="idCampo" v-model="texto" :placeholder="placeholder" autocomplete="off" @focus="aberto = true" @input="aberto = true" @blur="fechar" @keydown.esc="aberto = false")
    small.ajuda(v-if="!busca && texto") {{ filtrados.length }} de {{ itens.length }} ·&nbsp;
      a(href="#" @mousedown.prevent="verTodos") ver todos
    small.ajuda(v-else-if="!busca") {{ itens.length }} opções
    ul.opcoes(v-if="aberto && filtrados.length")
      li(v-for="i in filtrados.slice(0, limite)" :key="i.id" @mousedown.prevent="escolher(i)")
        b {{ i.id }}
        span {{ i.nome }}
      li.mais(v-if="filtrados.length > limite") Mais {{ filtrados.length - limite }}. Refine o filtro.
    p.vazio(v-if="aberto && texto.length > 1 && !filtrados.length") Nada encontrado com "{{ texto }}".
</template>

<script>
// Campo de texto que filtra uma lista de { id, nome } e devolve o item escolhido por v-model.
// Com `busca`, a lista vem de fora (função assíncrona por trecho de texto), para cadastros
// grandes como o de cidades. Serve ao tipo de serviço e à cidade da praça V.tal.
const normalizar = (s) => (s || "").toString().normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase()

export default {
  name: "SeletorFiltro",
  props: {
    itens: { type: Array, default: () => [] },
    value: Object,
    placeholder: String,
    filtroInicial: String,
    busca: Function,
    idCampo: String,
    limite: { type: Number, default: 40 },
    minimoBusca: { type: Number, default: 2 },
    esperaBusca: { type: Number, default: 250 },
  },
  data() {
    return { texto: this.filtroInicial || "", aberto: false, remotos: [], timer: null }
  },
  computed: {
    filtrados() {
      if (this.busca) return this.remotos
      const t = normalizar(this.texto)
      if (!t) return this.itens
      return this.itens.filter(i => normalizar(i.nome).includes(t) || String(i.id) === t)
    },
  },
  watch: {
    texto(t) { if (this.busca) this.agendarBusca(t) },
    filtroInicial(v) { if (!this.value) this.texto = v || "" },
  },
  methods: {
    agendarBusca(t) {
      clearTimeout(this.timer)
      if (t.trim().length < this.minimoBusca) { this.remotos = []; return }
      this.timer = setTimeout(() => this.buscarRemotos(t.trim()), this.esperaBusca)
    },
    async buscarRemotos(t) {
      this.remotos = await this.busca(t)
    },
    escolher(i) {
      this.$emit("input", i)
      this.aberto = false
    },
    limpar() {
      this.$emit("input", null)
      this.texto = this.filtroInicial || ""
      this.$nextTick(() => { const el = this.$el.querySelector("input"); if (el) el.focus() })
    },
    fechar() { setTimeout(() => { this.aberto = false }, 150) },
    verTodos() { this.texto = ""; this.aberto = true },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.seletor-filtro
  position: relative
  .input
    width: 100%
    box-sizing: border-box
  .ajuda
    display: block
    margin-top: 4px
    color: $gray-5
    font-size: 12px
    a
      color: $purple
  .opcoes
    position: absolute
    z-index: 50
    left: 0
    right: 0
    margin: 4px 0 0
    padding: 0
    list-style: none
    background: white
    border: 1px solid $white-6
    border-radius: 8px
    box-shadow: $shadow
    max-height: 260px
    overflow: auto
    li
      display: flex
      gap: 10px
      padding: 10px 12px
      border-bottom: 1px solid $white-8
      cursor: pointer
      font-size: 13px
      b
        min-width: 44px
        color: $purple
      &:hover
        background: $purple
        color: white
        b
          color: white
      &.mais
        color: $gray-5
        cursor: default
        font-style: italic
  .vazio
    margin: 4px 0 0
    font-size: 12px
    color: $gray-5
  .chip
    min-height: 44px
    box-sizing: border-box
    padding: 6px 8px 6px 12px
    background: rgba($purple, .08)
    border: 1.6px solid $purple
    border-radius: 8px
    b
      color: $purple
      margin-right: 10px
    span
      flex: 1
      font-size: 13px
    .chip-x
      border: none
      background: white
      color: $gray-5
      width: 28px
      height: 28px
      border-radius: 50%
      cursor: pointer
      font-size: 18px
      line-height: 1
      &:hover
        color: $red
</style>
